import { render, staticRenderFns } from "./Appstauber.vue?vue&type=template&id=0c25284a"
import script from "./Appstauber.vue?vue&type=script&lang=js"
export * from "./Appstauber.vue?vue&type=script&lang=js"
import style0 from "./Appstauber.vue?vue&type=style&index=0&id=0c25284a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports